import { render } from "./RulesDetail.vue?vue&type=template&id=9711d928&scoped=true"
import script from "./RulesDetail.vue?vue&type=script&lang=js"
export * from "./RulesDetail.vue?vue&type=script&lang=js"

import "./RulesDetail.vue?vue&type=style&index=0&id=9711d928&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9711d928"]])

export default __exports__